<template>
  <ElInput
    class="el-input__limit-clearable"
    v-model.trim="data.value"
    :maxlength="data.text.maxLength"
    :placeholder="placeholder"
    :readonly="readonly"
    clearable
    show-word-limit
  >
    <WidgetSourceIcon
      v-if="data.sourceItem && data.sourceItem.icon"
      slot="prefix"
      class="el-input__icon"
      :data="data"
    />
  </ElInput>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { Widget } from '@/models'
import { getTextPlaceholder } from '../input/utils'
import WidgetSourceIcon from '@/components/widget-source/WidgetSourceIcon.vue'

/** 身份证号填写 */
export default defineComponent({
  name: 'FaIdFill',

  components: { WidgetSourceIcon },

  props: {
    /** 控件数据 */
    data: {
      type: Widget,
      required: true
    },

    /** 是否只读 */
    readonly: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    return {
      /** 占位 */
      placeholder: computed(() => getTextPlaceholder(props.data))
    }
  }
})
</script>
